module.exports = __webpack_public_path__ + "static/img/icon-class.b870d4bd.png";